import { database } from 'lib_ui-services';
export default {
    verb: 'doingView',
    namespace: 'application',
    relation: 'notification',
    description: 'Mark one or all existing notifications as viewed',
    //this is the actual logic:
    logic: doingView
};

async function doingView({ data, payload, context }) {
    const db = database.get();
    const record = data || payload;
    const _id = record && (record.id || record._id);
    const criteria = _id ? { _id } : {};
    await db.updateMany({ criteria, operations: { $set: { seen: true } } }, context);
}
